import React from 'react'
import { useState } from 'react'
import "./styles/Admin.css"
import axios from 'axios';
import { error } from 'jquery';

function AdminLogin() {
    const [result, setResult] = useState("");

    const handleLogin = async () => {
        axios.get("http://localhost:8000/server.php")
        .then(response => {
            setResult(response.data);
            console.log(result);
        })
        .catch(
            error => {
                console.log(error);
            }
        )
    }
 


  return (
    <div className='contentContainer'>
        <button onClick={() => handleLogin()}>Click!</button>
    </div>
  )
}

export default AdminLogin